<template>
  <v-dialog v-model="dialog" width="600" scrollable persistent>
    <v-card v-if="dialog">
      <v-card-title>
        {{ contatoAtivo.id ? "Detalhes do contato" : "Novo contato" }}
        <v-btn
          color="primary"
          outlined
          class="ml-2"
          small
          @click="editando = true"
          :disabled="editando"
        >
          <v-icon small class="mr-2">mdi-pencil</v-icon>
          {{ editando ? "EDITANDO..." : "EDITAR" }}
        </v-btn>
        <v-spacer />
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-0">
        <contato-detalhes v-model="contatoAtivo" :editando="editando" />
      </v-card-text>
      <v-card-actions v-if="editando">
        <v-spacer />
        <v-btn text @click="dialog = false">CANCELAR</v-btn>
        <v-btn color="primary" depressed @click="salvar()" :disabled="invalido">CONFIRMAR</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import ContatoDetalhes from "./ContatoDetalhes";
export default {
  components: { ContatoDetalhes },
  data() {
    return {
      editando: false,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.$store.state.contato.contatoAtivo !== null;
      },
      set(val) {
        if (!val) {
          this.$store.commit("contato/setContatoAtivo", null);
        }
      },
    },
    invalido() {
      return (
        this.contatoAtivo.nome === "" ||
        this.contatoAtivo.telefones.length + this.contatoAtivo.emails.length ===
          0 ||
        this.contatoAtivo.tipos.length === 0
      );
    },
    ...mapState({
      contatoAtivo: (state) => state.contato.contatoAtivo,
      perms: (state) => state.usuarios.usuarioAtivo.permissoes,
    }),
  },
  methods: {
    salvar() {
      const contato = _.clone(this.contatoAtivo);
      contato.novo = contato.novo || !contato.id;
      contato.editar = !contato.novo && contato.id !== "";
      this.$emit("confirm", contato);
      this.dialog = false;
    },
  },
  watch: {
    dialog(val) {
      this.editando = val && !this.contatoAtivo.id;
    },
  },
};
</script>
